import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

const QUERY = graphql(`
  query customers_v2($companyId: ID!, $take: Int, $skip: Int) {
    customers_v2(companyId: $companyId, take: $take, skip: $skip) {
      id
      customerVariants {
        id
        name
        email
        phone
        createdAt
        nailAppointment {
          ...NailAppointmentItem
        }
      }
    }
  }
`);

export default function useCustomersV2(companyId: string, skip: number, take: number) {
  return useQuery(QUERY, {
    variables: { companyId, take, skip },
  });
}
